import { IconChevronSmallDown } from '@tock/icons';
import { InputAdornment, SelectProps as MuiSelectProps } from '@material-ui/core';
import { Theme } from '@emotion/react';
import {
  inputBaseSelect,
  startAdornmentStyles,
} from 'omakase/FormControls/formControlInputCssDefs';
import FormControlInputCore, {
  FormControlInputCoreProps,
  FormControlInputVariantProp,
  getHelperTextId,
} from 'omakase/FormControls/FormControlInputCore';
import MuiSelect from '@material-ui/core/Select';
import React from 'react';

export interface SelectOwnProps {
  /**
   * Start adornment for the component
   */
  startAdornment?: React.ReactNode;
  /**
   * Whether the current option should be rendered / styled as a placeholder
   */
  showPlaceholderStyles?: boolean;
}

export type SelectProps = SelectOwnProps &
  FormControlInputVariantProp &
  FormControlInputCoreProps &
  Omit<MuiSelectProps, 'variant'>;

const SelectField: React.FunctionComponent<SelectProps> = ({
  children,
  disabled,
  error,
  label,
  warn,
  valid,
  endAdornment: endAdornmentElement,
  startAdornment: startAdornmentElement,
  labelAdornment: helperTextLink,
  helperText,
  variant = 'basic',
  placeholder,
  showPlaceholderStyles: placeholderActive = false,
  id,
  native = true,
  ...rest
}) => {
  return (
    <FormControlInputCore
      disabled={disabled}
      error={error}
      label={label}
      labelAdornment={helperTextLink}
      helperText={helperText}
      id={id}
      warn={warn}
      valid={valid}
    >
      <MuiSelect
        css={(theme: Theme) => inputBaseSelect(theme, variant, { placeholderActive })}
        startAdornment={
          startAdornmentElement ? (
            <InputAdornment css={startAdornmentStyles} position="start">
              {startAdornmentElement}
            </InputAdornment>
          ) : undefined
        }
        IconComponent={IconChevronSmallDown}
        id={id}
        aria-describedby={helperText ? getHelperTextId(id) : undefined}
        native={native}
        inputProps={{ defaultValue: placeholder ? '' : undefined }}
        {...rest}
      >
        {placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}
        {children}
      </MuiSelect>
    </FormControlInputCore>
  );
};

export default SelectField;
